export const FETCH_REPORTS_REQUEST = 'FETCH_REPORTS_REQUEST';
export const FETCH_REPORTS_SUCCESS = 'FETCH_REPORTS_SUCCESS';
export const FETCH_REPORTS_FAILED = 'FETCH_REPORTS_FAILED';

export const FETCH_DEFAULT_REPORTS_REQUEST = 'FETCH_DEFAULT_REPORTS_REQUEST';
export const FETCH_DEFAULT_REPORTS_SUCCESS = 'FETCH_DEFAULT_REPORTS_SUCCESS';
export const FETCH_DEFAULT_REPORTS_FAILED = 'FETCH_DEFAULT_REPORTS_FAILED';

export const FETCH_REPORT_BY_ID_REQUEST = 'FETCH_REPORT_BY_ID_REQUEST';
export const FETCH_REPORT_BY_ID_SUCCESS = 'FETCH_REPORT_BY_ID_SUCCESS';
export const FETCH_REPORT_BY_ID_FAILED = 'FETCH_REPORT_BY_ID_FAILED';

export const DELETE_REPORT_BY_ID_REQUEST = 'DELETE_REPORT_BY_ID_REQUEST';
export const DELETE_REPORT_BY_ID_SUCCESS = 'DELETE_REPORT_BY_ID_SUCCESS';
export const DELETE_REPORT_BY_ID_FAILED = 'DELETE_REPORT_BY_ID_FAILED';

export const SEND_REPORT_TO_REQUESTER_BY_ID_REQUEST = 'SEND_REPORT_TO_REQUESTER_BY_ID_REQUEST';
export const SEND_REPORT_TO_REQUESTER_BY_ID_SUCCESS = 'SEND_REPORT_TO_REQUESTER_BY_ID_SUCCESS';
export const SEND_REPORT_TO_REQUESTER_BY_ID_FAILED = 'SEND_REPORT_TO_REQUESTER_BY_ID_FAILED';

export const CREATE_REPORT_REQUEST = 'CREATE_REPORT_REQUEST';
export const CREATE_REPORT_SUCCESS = 'CREATE_REPORT_SUCCESS';
export const CREATE_REPORT_FAILED = 'CREATE_REPORT_FAILED';

export const UPDATE_REPORT_REQUEST = 'UPDATE_REPORT_REQUEST';
export const UPDATE_REPORT_SUCCESS = 'UPDATE_REPORT_SUCCESS';
export const UPDATE_REPORT_FAILED = 'UPDATE_REPORT_FAILED';

export const DOWNLOAD_REPORT_REQUEST = 'DOWNLOAD_REPORT_REQUEST';
export const DOWNLOAD_REPORT_SUCESS = 'DOWNLOAD_REPORT_SUCESS';
export const DOWNLOAD_REPORT_FAILED = 'DOWNLOAD_REPORT_FAILED';
